
export const USER_API = {

    // LOGIN: 'user/authenticate',
    LOGIN: 'auth/authenticate',
    LOGIN_VERIFY: 'auth/loginVerifyOtp',
    LOGOUT: 'user/logout',
    SCREEN_ROUTES: 'user/screenRoutes',

    FORGOT_PASSWORD: 'user/forgetPassword',
    CHANGE_PASSWORD: 'user/changePassword',

    USERS: 'user/fetchAllUsers',
    CREATE_USER: 'user/createUser',
    UPDATE_USER: 'user/updateUser',
    DELETE_USER: 'user/deleteUser',
    USER_BY_ID: 'user/getUserDetailsByUserId',
    ALL_COUNTRY: 'user/getAllCountry',
    DOCUMENTS_REQUIRED: 'user/documentsRequiredDropdown',
    UPDATE_MOBILE_NUMBER: 'user/updateMobileNumber',

    ROLES: 'user/fetchAllRoles',
    CREATE_ROLE: 'user/createRole',
    DEACTIVATE_ROLE: 'user/deactivateRole',
    UPDATE_ROLE: 'user/updateRole',
    ROLE_PERMISSION: 'user/rolePermission',
    VIEW_ROLE_PERMISSION: 'user/viewRoleDetails',
    UPDATE_ROLE_PERMISSION: 'user/AllowPermission',

    ORDERS: 'orders/fetchAllOrders',
    CREATE_ORDER: 'orders/createOrders',
    UPDATE_ORDER: 'orders/updateOrder',
    ORDER_BY_ID: 'orders/getOrderById',
    ORDER_STATUS_DROPDOWN: 'orders/OrderStatusDropdown',
    ORDER_CHANNEL_DROPDOWN: 'orders/getchannelDropDown',
    ORDER_TYPE_DROPDOWN: 'orders/ordertype-dropdown',
    DOWNLOAD_ORDER: 'orders/export-all-orders',
    DELETE_ORDER: 'orders/deleteOrder',

    KITS: 'kits/fetchAllKitSample',
    UPDATE_KIT_STATUS: 'kits/updateKitStatus',
    KIT_STATUS_DROPDOWN: 'kits/getKitsStatusDropDown',
    SAVE_KIT_SAMPLE: 'kits/saveKitSample',
    DOWNLOAD_KIT: 'kits/downloadKitList',
    KIT_DROPDOWN_STATUS: 'kits/kitNewStatus',


    CLIENTS: 'user/fetchAllClient',
    CREATE_CLIENT: 'user/saveClient',
    UPDATE_CLIENT: 'user/updateClient',
    CLIENT_BY_ID: 'user/getClientDetailsByClientId',
    CLIENT_DROPDOWN: 'user/fetchAllClientName',
    DOWNLOAD_CLIENT: 'user/downloadClientList',

    PRODUCTS: 'user/fetchAllAnalysis',
    CREATE_PRODUCTS: 'user/createAnalysis',
    UPDATE_PRODUCTS: 'user/updateAnalysis',
    PRODUCTS_NAME: 'user/getDnaAnalysisName',
    PRODUCTS_STAGE_NAME: 'user/getStageMasterName-Product',

    SCRIPTS: 'script/fetchAllScriptProgram',
    CREATE_SCRIPTS: 'script/createScript',
    REVERT_SCRIPTS: 'script/revertScript',
    SCRIPT_ANALYSIS: 'script/fetchAllScriptByAnalysisId',
    STAGE_DROPDOWN: 'user/getStageMasterName',
    ANALYSIS_DROPDOWN: 'user/getDnaAnalysisName',
    GENERATE_OTP: 'script/generateOtp',
    VERIFY_OTP: 'script/verifyOtp',

    GET_ALL_ML_SCRIPTS: 'script/list-ml-script-versions',
    ACTIVATE_ML_SCRIPTS: 'script/set-active-ml-script-version',

    BATCHES: 'batch/fetchAllBatch',
    CREATE_BATCH: 'batch/createBatch',
    SAMPLE_BY_BATCH_ID: 'batch/fetchAllSampleByBatchId',
    CREATE_SAMPLE: 'batch/createSample',
    UPDATE_SAMPLE: 'batch/updateSample',
    ALL_ACTIVE_BARCODES: 'batch/getAllActiveBarcode',
    ADD_BARCODE_INSIDE_BATCH: 'batch/addBarcodeInsideBatch',
    DELETE_SAMPLE: 'batch/deleteSample',
    DOWNLOAD_BATCH: 'batch/downloadSampleExcel',
    CREATE_NUCLIQ_CODE: "batch/createNucliqCode",
    HISTORY_OF_SAMPLE: "batch/sampleHistoryBySampleId",
    HISTORY_OF_NUCLIQ_CODE: "batch/fetchAllNucliqcodeAndBarcode",

    UPDATE_BATCHES_STATUS: 'batch/updateBatch',
    BATCHES_BY_ID: 'batch/getBatchDetailsByBatchId',
    BATCH_DROPDOWN: 'batch/fetchAllBatchStatus',

    BIOINFORMATICS: 'batch/fetchAllBatchsByStage',
    BATCH_STATUS_DROPDOWN: 'batch/statusDropDownForAnalysis',
    UPDATE_BATCH_STATUS: 'batch/updateBatchStatus',
    UPLOAD_FASTQ_FILE: 'batch/uploadFastQFiles',
    UPLOAD_FASTQ_FILE_FOR_SAMPLE: 'batch/uploadFastQFilesForSample',
    MOVE_TO_STAGES: 'batch/moveStage',
    BIOINFORMATICS_STATUS_DROPDOWN: 'batch/statusDropDownForBioInformatics',
    // EXECUTE_BIOINFORMATICES: 'script/run-nextflow',
    EXECUTE_BIOINFORMATICES: 'script/run-nextflow-new',

    UPDATE_SAMPLE_STATUS: 'batch/updateSampleStatus',
    BIOINFORMATICS_OUTPUT: 'script/bioinformatics-output',
    VIEW_FASTQ_FILES_BY_BATCH: 'batch/viewFastQFilesByBatchId',
    ML_OUTPUT: 'script/ml-output',
    R_ANALYSIS_OUTPUT: 'script/ranalysis-output',
    REPROCESS_FAILED_SAMPLES: 'batch/reprocessFailedSamples',

    // EXECUTE_ML_ANALYSIS: 'script/execute-disease-prediction',
    EXECUTE_ML_ANALYSIS: 'script/execute-ml-workflow',
    EXECUTE_R_ANALYSIS: 'script/run-R',
    SAMPLE_OF_BIOINFORMATICES: 'batch/fetchAllSampleforBioInformatics',
    SAMPLE_OF_ML_ANALYSIS: 'batch/fetchAllSampleforMLAnalysis',
    SAMPLE_OF_R_ANALYSIS: 'batch/fetchAllSampleforRAnalysis',
    SAMPLE_OF_REPORT_GENERATION: 'batch/fetchAllSampleforReportGeneration',
    EXECUTE_REPORT_GENERATION: 'script/generate-partner-report',
    FINAL_REPORT_GENERATION: 'script/finalreportgeneration',
    GENERATED_REPORTS: 'script/generated-reports',
    VIEW_GENERATED_REPORT: 'script/generated-reports/view',
    DOWNLOAD_ALL_REPORTS: 'script/downloadAllReports',
    SAMPLE_OF_QUALITY_CONTROL: 'batch/fetchAllSampleforQualityControl',

    SAMPLE_CREATE_COLUMN: 'batch/createColumn',
    SAMPLE_DOWNLOAD_BATCH: 'batch/downloadMetadataFile',
    SAMPLE_FILE_UPLOAD: 'batch/uploadMetadataFile',
    GENERATE_SAMPLE_METADATA_COLUMNS: 'batch/generateMetadataTSV',


    UPLOAD_FASTQ_FILE_FOR_BATCH: 'batch/uploadFastQFilesForBatch',
    DOWNLOAD_SCRIPT: 'script/downloadBioInformatics',

    METADATA: 'kits/fetchAllMetaData',
    GET_JSON_KEY: 'kits/fetchAllJsonKey',

    GET_JSON_KEY_BATCH_ID: 'kits/fetchAllJsonKeyByBatch',
    DOWNLOAD_COLUMN: 'batch/downloadSelectedColumn',

    REPORT_TEMPLATE: 'reportTemplate/getAllTemplates',
    REPORT_TEMPLATE_BY_ID: "reportTemplate/fetchTemplateByTemplateId",
    HISTORY_OF_REPORT_TEMPLATE: "reportTemplate/getTemplateHistory",
    REVERT_REPORT_TEMPLATE: "reportTemplate/revertReportTemplate",
    DELETE_REPORT_TEMPLATE: "reportTemplate/deleteTemplate",
    REPORT_TEMPLATE_PRODUCT_ID: "reportTemplate/fetchAllTemplateByAnalysisId",
    REPORT_TEMPLATE_DOWNLOAD: "batch/viewFile",

    USER_ACTIVITY_DROPDOWN: 'userActivity/userActivityDropDown',
    USER_ACTIVITY_ACTIVITY_LOG_LIST: 'userActivity/activityLogList',
    ACTIVE_USER_DROPDOWN: 'user/activeUserdropdown',

    GET_COMMENTS: 'comments/getComments',
    SAVE_COMMENT: 'comments/saveComment',
    UPDATE_COMMENT: 'comments/updateComment',

    KIT_STATUS_TOTALCOUNT: 'dashboard/kitStatusTotalCount',
    KIT_STATUS_CHART_TOTALCOUNT: 'dashboard/kitStatusChartTotalCount',
    ORDER_COUNT: 'dashboard/order-count',
    BATCH_NAME_STATUS: 'dashboard/dashboardBatchStatus',
    TOTAL_ORDERS: 'dashboard/current-kit-count',
    DASHBOARD_BATCH_NAME: 'dashboard/dashboardBatchName',
    DASHBOARD_MONTH_NAME: 'dashboard/getAllMonthName',
    DASHBOARD_MONTHLY_KIT_COUNT: 'dashboard/monthlyKitCount',
    DASHBOARD_kIT_TREND: 'dashboard/kit-trend',
    DASHBOARD_INVENTORY: 'inventory/inventory-Dashboard',


    HEALTH_DROPDOWN: 'user/health-dropdown',
    DATA_CURATION: 'dataCuration/fetchAllDataCuration',
    DATA_CURATION_HISTORY: 'dataCuration/dataCurationHistory',
    UPLOAD_DATA_CURATION: 'dataCuration/createDataCuration',
    REVERT_DATA_CURATION: 'dataCuration/revertDataCuration',

    CREATE_UPDATE_FREEZER_ITEM: 'inventory/create-minum80DegreeFreezer',
    SAMPLE_TYPE_DROPDOWN: 'inventory/sample-types',
    GET_FREEZER_DETAILS: 'inventory/fetchAll-minus80DegreeFreezer',
    DELETE_FREEZER_SAMPLE: 'inventory/delete-FreezerSample',
    DOWNLOAD_FREEZER: 'inventory/export-all-minus80DegreeFreezer',

    GET_INVENTORY_COLUMN: 'inventory/inventory-title',
    CREATE_UPDATE_INVENTORY_COLUMN: 'inventory/create-title',
    DELETE_INVENTORY_COLUMN: 'inventory/delete-title',

    CREATE_UPDATE_LAB_CONSUMABLES: 'inventory/createLabConsumable',
    GET_ALL_LAB_CONSUMABLES: 'inventory/fetchAllLabConsumable',
    GET_HISTORY_LAB_CONSUMABLES: 'inventory/fetchConsumableHistoryByConsumableId',
    DOWNLOAD_LAB_CONSUMABLES: 'inventory/downloadLabConsumableList',



    GET_ALL_GUTCHECK_SUPPLIES: 'inventory/fetchAll-GutcheckSupplies',
    GET_HISTORY_GUTCHECK_SUPPLIES: 'inventory/fetchAll-gutcheckSupply-history',
    CREATE_GUTCHECK_SUPPLIES: 'inventory/create-gutcheckSupply',
    DOWNLOAD_GUTCHECK_SUPPLIES: 'inventory/export-all-GutcheckSupplies',


    SAMPLE_BATCH_TEMPLATE: 'batch/sendMailForRoadMap',


    SCRIPTS_ROOT_PATH_NAME: 'script/getRootPathName',
    SCRIPTS_NEXTFLOW_FAST_Q_FILES: 'script/createNextflowFastQFiles',
    GROUPED_FASTQ_UPLOAD_PLAN: 'script/grouped-fastq-upload/plan',
    GROUPED_FASTQ_UPLOAD: 'script/grouped-fastq-upload/upload',


    PRODUCT_NAME_BY_COUNTRY_ID: 'user/getDnaAnalysisNameByCountryId',

}